"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectionSelectInput = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var ErrorMessage_1 = require("../ErrorMessage");
var FieldHeading_1 = require("../FieldHeading");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var Select_1 = require("../Select");
var shared_1 = require("./shared");
var SingleSelectionSelectInput = function (_a) {
    var propertyId = _a.propertyId, value = _a.value, errorMessages = _a.errorMessages, disabled = _a.disabled, className = _a.className, displayError = _a.displayError, items = _a.items, displayChoiceNumber = _a.displayChoiceNumber, onSelectChange = _a.onSelectChange;
    var handleSelectChange = function (e) {
        if (e.target.value === '') {
            onSelectChange(null);
            return;
        }
        onSelectChange(Number(e.target.value));
    };
    var unselectedItem = items.find(function (item) { return item.value == null; });
    var nonNullableItems = items.filter(function (item) { return item.value != null; });
    return (react_1.default.createElement(PropertyInputWrapper_1.PropertyInputWrapper, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.singleSelection, inputFormatType: models_1.SINGLE_SELECTION_PROPERTY_INPUT_TYPE.pulldown, errorMessages: errorMessages, className: className, displayError: displayError },
        react_1.default.createElement(Select_1.Select, { "data-cy-property-item": true, value: shared_1.convertItemValueIntoInputValue(value), error: displayError, disabled: disabled, onChange: handleSelectChange, "aria-labelledby": FieldHeading_1.getLabelId(propertyId), "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) },
            unselectedItem && (react_1.default.createElement("option", { value: shared_1.convertItemValueIntoInputValue(unselectedItem.value) }, unselectedItem.label)),
            nonNullableItems.map(function (item, i) { return (react_1.default.createElement("option", { key: item.value, value: shared_1.convertItemValueIntoInputValue(item.value) }, displayChoiceNumber ? i + 1 + ". " + item.label : item.label)); }))));
};
exports.SingleSelectionSelectInput = SingleSelectionSelectInput;
